import React, { FC, useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import myPostWrapper from '../../../hoc/myPostWrapper';
import RegisterShipmentForm from '../../registerShipment/registerShipmentForm';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';
import { getQueryParam } from '../../../helpers/url/urlHelpers';
import IPostService from '../../../interfaces/forms/postService';
import usePostalServices from '../../../hooks/usePostalServices';
import {
	resetToInitalValues,
	stepInfoFulfilled,
	stepShipmentFulfilled,
} from '../../../actions/registerShipmentActions';
import { useDispatch, useSelector } from 'react-redux';
import usePostCodes from '../../../hooks/usePostCodes';
import { useTranslation } from 'react-i18next';

interface PresetRecipient {
	name: string;
	address: string;
	ssn: string;
	postcode: string;
}

interface Props {
	page: IPageViewModel;
}

const MyRegisterShipment: FC<Props> = ({ page }) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('myShipments');
	const { userProfile } = useSelector(({ userProfileReducer }) => userProfileReducer);
	const { stepInfoFormInfo } = useSelector(({ registerShipmentReducer }) => registerShipmentReducer);
	
	const [presetDataDispatched, setPresetDataDispatched] = useState(false);
	const { postCodes, postCodesLoading } = usePostCodes();
	
	const presetRecipient: PresetRecipient | null = (() => {
		const isReturn = getQueryParam('isReturn') === 'true';
		if (isReturn) {
			return {
				name: "Metta Sport",
				address: "Barónsstígur 11a",
				ssn: "6203211170",
				postcode: "101"
			};
		}
		return null;
	})();
	
	useEffect(() => {
		if (presetRecipient && userProfile && !presetDataDispatched && postCodes && !postCodesLoading) {
			setPresetDataDispatched(true)
			dispatch(stepInfoFulfilled({
				...stepInfoFormInfo,
				receiverName: presetRecipient.name,
				receiverAddress: presetRecipient.address,
				receiverSsn: presetRecipient.ssn,
				receiverPostCode: {
					value: presetRecipient.postcode,
					label: postCodes.find(x => x.value === presetRecipient.postcode)?.label
				},
				
				senderSsn: userProfile.identificationNumber || '',
				senderName: userProfile.name || '',
				senderAddress: userProfile.currentAddress?.street1 || '',
				senderEmail: userProfile.email || '',
				senderPostCode: {
					value: userProfile.currentAddress?.postalCode,
					label: postCodes.find(x => x.value === userProfile.currentAddress?.postalCode)?.label,
				},
				senderPhone:
					(userProfile?.phoneNumber &&
					userProfile.phoneNumber.length === 11 &&
					userProfile.phoneNumber.substring(0, 4) === '+354'
						? userProfile.phoneNumber.substring(4)
						: userProfile.phoneNumber) || '',
			}));
			
			dispatch(stepShipmentFulfilled({
				service: "Parcel",
				optionalServices: [],
				optionalServicesNames: [],
				parcelCount: 1,
				dontKnowWeight: false,
				parcelWeight: 2,
				weightCategory: '',
				serviceOption: "PostOffice",
				serviceName: t('postoffice'),
				serviceOptionPostbox: null,
				serviceOptionParcelpoint: null,
				parcelWidth: "",
				parcelHeight: "",
				parcelLength: "",
				price: "",
				codAmount: "",
				codSsn: "",
				codBank: "",
				codAccountType: "",
				codAccount: "",
				codReference: "",
				insuranceAmount: "",
				insuranceTerms: false,
				receiverPhone: "",
				receiverPhoneCountryCode: "IS",
				senderSsnValid: true,
			}));
		}
	}, [presetRecipient, stepInfoFormInfo, userProfile, dispatch, postCodes, postCodesLoading, presetDataDispatched, t]);

	return (
		<RegisterShipmentForm page={page} side="right" presetRecipient={presetRecipient} />
	);
};

export default myPostWrapper(MyRegisterShipment);
